import AdminAddDashboardsAreas from '@src/main/ui/components/AdminAddDashboards/AdminAddDashboardsAreas';
import { type FC } from 'react';

const AdminAddDashboardsAreasPage: FC = () => <AdminAddDashboardsAreas />;

export default AdminAddDashboardsAreasPage;
